var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270 480",
    style: {
      enableBackground: "new 0 0 270 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D0DE8E;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st2{fill:#F9DB00;}\n\t.st3{fill:#1F54B0;}\n\t.st4{fill:#D03632;}\n\t.st5{fill:#D1D1D1;}\n\t.st6{fill:#4C702B;}\n\t.st7{fill:#93B838;}\n\t.st8{fill:#B1CC40;}\n\t.st9{fill:#CAF741;}\n\t.st10{fill:#FEF7CE;}\n\t.st11{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.8,474.6c3.5-0.1,3.8-3.4,3.9-4.5s0.6-6.4-3.9-6.6s-4.4,4.3-4.5,5.1C136.4,469.4,136.2,474.5,140.8,474.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.3,443.3c0-7.5-0.3-13.1,4.7-13.2c4.7-0.1,4.2,5.4,4.2,12.7c0,8.1-0.1,11.9-4.3,11.9 C136.2,454.7,135.3,451.9,135.3,443.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.4,412.1c3.4-0.2,3.7-3.5,3.7-4.6s-0.1-6.6-0.3-9.2c-0.1-1.4-0.7-4.9-4.6-4.8s-4.1,4.4-4.1,5.7 c0,1,0.4,6.5,0.4,7.2S135.7,412.2,140.4,412.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.1,450.8c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8s-1.7,3.8-3.8,3.8C137.8,454.6,136.1,452.9,136.1,450.8 C136.1,450.9,136.1,450.8,136.1,450.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.4,436.8c0-2.1,1.7-3.8,3.7-3.8c2.1,0,3.8,1.7,3.8,3.7c0,2.1-1.7,3.8-3.7,3.8c0,0,0,0,0,0 C138.1,440.6,136.4,438.9,136.4,436.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136.3,408.2c0-2.1,1.7-3.8,3.7-3.8s3.8,1.7,3.8,3.7c0,2.1-1.7,3.8-3.7,3.8c0,0,0,0,0,0 C138,411.9,136.3,410.2,136.3,408.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M135.8,397.3c0-2.1,1.7-3.8,3.7-3.8s3.8,1.7,3.8,3.7c0,2.1-1.7,3.8-3.7,3.8c0,0,0,0,0,0 C137.5,401,135.8,399.4,135.8,397.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Weg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M151.2,479.5L183,0.7c-0.6,0.8-1.8,0.9-2.6,0.2c-0.1-0.1-0.2-0.2-0.2-0.2c-0.6-0.8-1.7-0.9-2.5-0.3 c-0.1,0.1-0.2,0.2-0.3,0.3c0,0-0.6,10.8-0.8,13.1c-0.4,4.5-3.6,6.9-9.9,3.2c-2.7-1.6-27.4-15.7-27.4-15.7S140.6,3,138,3 s-1.6,2-1.6,2l29.3,17c0,0,6.4,3.1,8.6,8.3c1.5,3.8,0.7,10.9,0.7,10.9l-26.9,414c-1.7,1.6-3.7,2.8-5.9,3.6 c-3.1,1.2-10.4,1.2-10.4,1.2l-20,0.2c-4-0.1-8.1,0.3-12,1.3c-3.6,1-7,2.8-9.9,5.2c0,0-0.3,1,1,1s1.2,1.3,1.2,1.3 c2.7-2.3,6-3.9,9.4-4.7c3.2-0.8,6.5-1.2,9.8-1.1l20.6-0.3c0,0,7.6,0,10.3-0.9c2-0.6,3.9-1.4,5.7-2.3l-1.5,19.9 c0.7,0.6,1.7,0.6,2.4,0C149.8,478.4,151.2,479.5,151.2,479.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M139.3,30.6c15-3.2,31,4.9,33.2,25c1.1,10.3,2,24.5-7.1,41.4c-5.4,10.1-3.7,20.5-5,37.4 c-1.4,18.2,3.6,22.7-1.1,60.3c-3.6,28.9-6.8,43.5-4.3,56.4c3.2,16.5-2.1,26.7-3.6,37.8c-1.4,10.5,5,55-20.3,54.6 c-22.8-0.4-13.7-25.7-19.6-42.8c-6.1-17.5-4.3-29-3.6-40.7c1.4-21.8-8.2-31.8-6.1-54.2c3.1-32.6-1.4-32.5,6.1-62.4 c3.9-15.8,6.3-24.4,2.5-41.7c-3.5-16.4,13.2-27.1,13.6-35.3C124.7,48.4,125.8,34.1,139.3,30.6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M151.6,96c-0.4,7.2,0,18.6-0.1,25.5c-0.1,6.9-1.2,26.2-2.9,35s-5.8,30.6-8,42.8c-1.3,7.5-1.9,11-0.2,18 s2.4,22.2,2.5,26.6c0.3,8.8,2.6,18.5,3.8,29.8c1.1,10.7-3.2,17.7-2.7,33.1c0.5,15.2-0.2,32-14.4,31.1c-10.7-0.7-8.4-14.5-8.1-22.6 s-0.3-39.4-3.1-55.4s-4-21.9-4.4-30.6c-0.1-1-0.5-1.9-1.1-2.7c-0.7-1.1-0.9-1.1-0.5-2.8c0.6-2.3,0.8-3.5,1.7-7.4 c2.1-9.8-0.6-7.9-0.4-10.8c0.1-2.3,5-8.1,6.4-18.7c0.2-1.3-0.4-2.3-0.1-4.2c0.3-1.7,1.2-1.2,2-2.1c4.6-5.2,1.7-11,1.4-15 c-0.9-12.3,2.5-26,4.6-37.2c4.2-22.8,6.6-26.3,8.3-33.6"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M155.9,62.6c-0.2,4.6,1.7,9.4-3.6,15c-2.1,2.2-1,7.7-0.8,14.6c0.1,4.3,0.9,11.2-6.6,11.1 c-4.7-0.1-9.9-0.4-8.7-8.2c0.7-3.2,0.9-6.6,0.6-9.9c-0.4-4,6.1-6.1,3.9-11.3c-0.9-2.1,0.4-3.9-1.9-6.7s-5.4-3.6-5.5-8 c-0.1-3.7,2.5-4.9,3.3-6.7c2.1-4.8-1.1-6.6,0.1-9.7c0.6-1.8,3.2-3.7,8.6-3.5c6.7,0.2,7.4,0.9,7.4,5.8c0,2.6-0.3,4.9,1.5,7.4 C156.2,55.2,156.1,58.1,155.9,62.6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M154.2,63.5c0,2.4,0.2,3.1,0,6.9c-0.2,3.5-2.8,6.5-6.3,7.1c-4.2,0.7-5.5-2.5-6-4.6s0.4-4.3-1.8-6.7 c-2.8-3-4.9-4.2-5.2-6.9c-0.3-3.2,2.9-4.4,3.7-7.4c0.8-3.2,4.1-5.2,7.3-4.3c0,0,0,0,0,0c3.4,0.7,8.3,5.4,8.4,9.9 C154.3,60.1,154.2,61.6,154.2,63.5"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M113.4,197.3c1.6,0.4,2.5,2.1,2.1,3.7c-0.1,0.2-0.2,0.5-0.3,0.7c-0.8,1.6-1.9,3.7-1.4,5.1 c0.2,0.5,1.8,2.4-0.5,3.8c-2,1-3.5-0.8-4.2-2.1c-1.1-1.7-0.2-4.4,0.3-7.5C110,197.4,112.1,196.9,113.4,197.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M119.4,173.2c-1.8-0.5-4.1,0.8-5.1,2.3c-1.2,1.9,0.5,4.1,0.5,5.8c0,2.4-2.3,5.5,1.1,7.2 c3.1,1.6,4-0.6,4.1-1.9c0.1-0.9-0.2-2.4-0.1-4.1c0.2-2.1,2.5-1,2.5-4.2S121,173.7,119.4,173.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M124.2,101.9c1.4,1.4,3.1,1,5-0.6c1.5-1.1,2.1-3,1.6-4.8c-0.9-4.3-2.5-2.6-5.2-6.1c-2-2.7-2.8-1.2-4.6-0.4 s-6.1,1.6-4.4,5.6c0.5,1.2,1.8,1.9,3.2,1.7c1.2-0.2,1.8-1.1,2.6-0.4C124.1,98.2,121.9,99.6,124.2,101.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M138.5,73.5c2.4,2.1,0.8,4.6-1.1,5.9c-2.3,1.6-4.5-0.6-7.1-3.6s-2.3-6-0.9-6.8c1.4-0.8,3.7,0.6,4.6,3.4 C134.8,74.8,136.9,72.1,138.5,73.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M161.6,62.9c-0.2,1.4-1.4,2.3-2.8,2.2c-1.4-0.2-2.3-1.4-2.2-2.8c0.1-1.2,1.1-2.1,2.3-2.2 C160.4,60.2,161.6,61.4,161.6,62.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M112.6,230.4c-3.2,1.8-5.4-2.7-6-4.1c-0.7-1.7-1-5.7,2.3-6.2c3.7-0.6,3.8,2,3.2,4.4 C111.7,226.4,115.8,228.6,112.6,230.4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M104.9,330.3c-0.8-0.1-1.6,0.2-2.2,0.8c-0.4-0.6-1.1-0.9-1.8-1c-0.5-0.1-1,0-1.5,0.2 c-0.3-0.3-0.7-0.5-1.2-0.6c0-0.1,0-0.2,0.1-0.3c0.2-1.4-0.8-2.8-2.3-3c-1.4-0.2-2.8,0.8-3,2.3c-0.1,0.7,0.1,1.3,0.4,1.9 c-1.4,0.5-2,2.1-1.5,3.4c0.3,0.8,1,1.4,1.8,1.6c-0.7,1.3-0.2,2.9,1,3.6c1.3,0.7,2.9,0.2,3.6-1c0.1-0.1,0.1-0.2,0.1-0.3 c0.1,0,0.2,0.1,0.3,0.1c1.4,0.2,2.8-0.8,3-2.2c0,0,0,0,0-0.1c0-0.2,0-0.5,0-0.7c0.2-0.1,0.4-0.2,0.5-0.4c0.9,1.2,2.5,1.4,3.7,0.6 c0.6-0.4,1-1.1,1.1-1.8c0.2-1.4-0.8-2.8-2.3-3C105.1,330.3,105,330.3,104.9,330.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M109.8,381.3c0.5-0.4,0.9-1,1-1.7c0.2-1.4-0.8-2.8-2.3-2.9c0,0,0,0,0,0h-0.2c0.2-0.3,0.3-0.7,0.4-1.1 c0.2-1.4-0.8-2.8-2.3-2.9c0,0,0,0,0,0c-0.4,0-0.7,0-1.1,0.1c0.1-0.2,0.1-0.3,0.1-0.5c0.1-0.5,0-1-0.2-1.4c1.5,0,2.7-1.1,2.7-2.5 c0-1.4-1-2.6-2.4-2.7c-1-0.1-1.9,0.3-2.5,1.1l-5.5-4c0.8-1.2,0.5-2.8-0.7-3.7c-1.2-0.8-2.8-0.5-3.7,0.7c-0.2,0.4-0.4,0.8-0.4,1.2 c-0.1,0.7,0.1,1.4,0.6,2c-1.4,0.3-2.3,1.8-1.9,3.2s1.8,2.3,3.2,1.9c0.2,0,0.4-0.1,0.5-0.2l0.9,8c-0.2-0.1-0.4-0.2-0.7-0.2 c-1.4-0.2-2.8,0.8-3,2.3c-0.1,1,0.3,2,1.1,2.5c-1.3,0.7-1.7,2.3-1,3.6c0.3,0.5,0.8,1,1.4,1.2c-0.1,0.2-0.1,0.4-0.1,0.7 c0,1.4,1.1,2.6,2.5,2.8c0.2,0.7,0.6,1.3,1.1,1.7c-0.6,0.5-1,1.3-1,2.1c0,1.6,1.3,2.8,2.8,2.8c0.1,0,0.3,0,0.4,0 c0.1,1.5,1.4,2.5,2.8,2.4c1.5-0.1,2.5-1.4,2.4-2.8c0-0.3-0.1-0.5-0.2-0.8c1.5,0.1,2.7-1,2.8-2.4c0.1-0.9-0.3-1.8-1.1-2.3 c0.7-0.4,1.3-1.2,1.3-2c0-0.3,0-0.6-0.1-0.9c0.2,0.1,0.4,0.1,0.6,0.1c1.4,0.2,2.8-0.9,2.9-2.3C111.4,382.9,110.8,381.8,109.8,381.3  M96,363.7C96,363.7,96,363.7,96,363.7L96,363.7L96,363.7z M105.8,384.2l0.2-0.2c0,0.1,0,0.2,0,0.2L105.8,384.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M107,248.5c-0.2-1.4-1.6-2.4-3-2.2l0,0c1.2-0.8,1.5-2.5,0.6-3.7c-0.2-0.3-0.4-0.5-0.7-0.7 c1.3-0.6,1.9-2.2,1.2-3.5c-0.5-1-1.6-1.6-2.7-1.5c-0.2,0-0.4,0.1-0.6,0.2c0.1-0.3,0.1-0.7,0-1c-0.2-1.4-1.6-2.4-3-2.2 c-0.9,0.1-1.6,0.7-2,1.6h-0.2c-1.6-0.1-2.9,1.2-2.9,2.7c-0.1,1.5,1.1,2.8,2.6,2.9l0,0c0.1,0.6,0.4,1.1,0.9,1.5c0,0.1,0,0.3,0,0.4 c0.2,1.1,1,2,2.1,2.2c-0.4,0.5-0.6,1.2-0.6,1.9c-0.4,0.3-0.7,0.8-0.8,1.2c-0.4-0.1-0.8-0.2-1.2-0.1c-1.4,0.2-2.4,1.5-2.2,3 c0.2,1.4,1.5,2.4,3,2.2c1-0.1,1.8-0.9,2.1-1.8c0.4,0.1,0.8,0.2,1.2,0.1c0.6-0.1,1.2-0.4,1.6-0.9c1,1,2.7,1,3.7,0 C106.8,250.2,107.1,249.3,107,248.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M104.6,262.1c0.1-0.3,0.1-0.5,0.1-0.8c0-1.6-1.3-2.8-2.8-2.8c-1.6,0-2.8,1.3-2.8,2.8c0,0,0,0,0,0 c0,0.3,0,0.5,0.1,0.8c-1.5,0.3-2.5,1.8-2.2,3.3c0.3,1.5,1.8,2.5,3.3,2.2c0.6-0.1,1.2-0.5,1.6-0.9c1,1.2,2.8,1.3,4,0.3 c1.2-1,1.3-2.8,0.3-4C105.8,262.6,105.2,262.3,104.6,262.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M97.6,189.1c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8C96.3,186.2,97.6,187.5,97.6,189.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M105.9,168.4c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8S105.9,166.8,105.9,168.4 L105.9,168.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M100.9,151c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8c0,0,0,0,0,0 C99.6,148.2,100.9,149.4,100.9,151"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M99.5,141c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8S99.5,139.4,99.5,141L99.5,141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M151.9,437.4c0.5-0.5,0.9-1.2,0.9-2c-0.1-1.6-1.4-2.8-3-2.7c-1.4,0.1-2.6,1.2-2.7,2.7c1.1,1.1,1.1,2.9,0,4 c0,0,0,0,0,0c0,1.6,1.2,2.9,2.8,2.9c1.6,0,2.9-1.2,2.9-2.8C152.8,438.7,152.4,438,151.9,437.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M181.5,263c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8h0 C180.2,260.2,181.5,261.4,181.5,263"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M193.4,257.8c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8C192.1,255,193.4,256.2,193.4,257.8 L193.4,257.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M184.4,220.9c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8 C183.1,218.1,184.4,219.4,184.4,220.9L184.4,220.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M196,215.7c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8c0,0,0,0,0,0 C194.7,212.9,196,214.1,196,215.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M196.5,205.5c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8 C195.2,202.6,196.5,203.9,196.5,205.5L196.5,205.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M206.9,221.4c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8 C205.7,218.6,206.9,219.8,206.9,221.4L206.9,221.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M208.1,200c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8C206.9,197.2,208.1,198.4,208.1,200 C208.1,200,208.1,200,208.1,200"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M208.6,187.4c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8 C207.3,184.6,208.6,185.8,208.6,187.4L208.6,187.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M186,178.1c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8 C184.7,175.3,186,176.6,186,178.1C186,178.1,186,178.1,186,178.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M187.3,166.7c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8 C186,163.9,187.3,165.1,187.3,166.7C187.3,166.7,187.3,166.7,187.3,166.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M199.6,151.2c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8 C198.3,148.4,199.6,149.7,199.6,151.2L199.6,151.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M212.4,147.2c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8 C211.1,144.4,212.4,145.6,212.4,147.2C212.4,147.2,212.4,147.2,212.4,147.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M200.1,140.3c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8c0,0,0,0,0,0 C198.8,137.5,200.1,138.7,200.1,140.3C200.1,140.3,200.1,140.3,200.1,140.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M201.5,128.4c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8 C200.2,125.6,201.5,126.9,201.5,128.4C201.5,128.4,201.5,128.4,201.5,128.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M202.4,117.2c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8c0,0,0,0,0,0 C201.2,114.4,202.4,115.7,202.4,117.2L202.4,117.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M191.3,111.5c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8C190,108.7,191.3,110,191.3,111.5 L191.3,111.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M201.8,105.4c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8 C200.5,102.5,201.8,103.8,201.8,105.4L201.8,105.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M204.6,94.2c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8c0,0,0,0,0,0 C203.3,91.3,204.6,92.6,204.6,94.2L204.6,94.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M194.3,57.8c0,1.6-1.2,2.8-2.8,2.9c-1.6,0-2.8-1.2-2.9-2.8s1.2-2.8,2.8-2.9c0,0,0,0,0,0 C193.1,55,194.3,56.3,194.3,57.8L194.3,57.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M195.8,46.9c0,1.6-1.3,2.8-2.9,2.8c-1.6,0-2.8-1.3-2.8-2.9c0-1.6,1.3-2.8,2.8-2.8 C194.5,44,195.8,45.3,195.8,46.9L195.8,46.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M206.9,53.5c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8l0,0 C205.7,50.7,206.9,52,206.9,53.5L206.9,53.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M207.9,42.3c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8l0,0 C206.6,39.5,207.9,40.8,207.9,42.3C207.9,42.3,207.9,42.3,207.9,42.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M218.6,36.2c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8c0,0,0,0,0,0 C217.3,33.3,218.6,34.6,218.6,36.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M207.9,31.6c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8C206.6,28.8,207.9,30.1,207.9,31.6 C207.9,31.6,207.9,31.6,207.9,31.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M155.7,446c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.5c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C157.7,441.5,155.7,443.5,155.7,446"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M124.8,440.4c0.6,2.5,3,4,5.4,3.4c2.5-0.6,4-3,3.4-5.4c-0.6-2.5-3-4-5.4-3.4c0,0,0,0,0,0 C125.8,435.6,124.2,438,124.8,440.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M151.8,313.4c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C153.8,308.8,151.8,310.9,151.8,313.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M151.5,379.3c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C153.6,374.8,151.5,376.8,151.5,379.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M151.5,359.3c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C153.6,354.8,151.5,356.8,151.5,359.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M151.5,350.5c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C153.6,346,151.5,348,151.5,350.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M150.7,328.4c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C152.8,323.8,150.7,325.8,150.7,328.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M163.2,319.1c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C165.3,314.5,163.2,316.6,163.2,319.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M172,316c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0C174,311.5,172,313.5,172,316"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M163.7,311.5c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C165.7,307,163.7,309,163.7,311.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M161.9,337c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C163.9,332.5,161.9,334.5,161.9,337"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M170.1,327.7c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C172.1,323.2,170.1,325.2,170.1,327.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M162.7,328.2c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.5c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C164.7,323.6,162.7,325.7,162.7,328.2C162.7,328.2,162.7,328.2,162.7,328.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M161.4,351.2c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.5c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C163.5,346.6,161.4,348.7,161.4,351.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M160.4,367.2c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C162.4,362.7,160.4,364.7,160.4,367.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M170.6,351.7c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C172.6,347.2,170.6,349.2,170.6,351.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M174.4,359.8c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C176.4,355.2,174.4,357.3,174.4,359.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M165.1,359.3c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C167.1,354.8,165.1,356.8,165.1,359.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M168.7,367.5c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C170.7,362.9,168.7,365,168.7,367.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M177.5,368.3c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.5c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C179.5,363.8,177.5,365.8,177.5,368.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M176.1,384.2c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C178.1,379.6,176.1,381.7,176.1,384.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M159.6,382.8c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C161.7,378.2,159.6,380.2,159.6,382.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M158.8,396.9c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C160.8,392.3,158.8,394.3,158.8,396.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M153.9,415.2c0-0.8-0.4-1.6-1-2.1c1.1-1.2,1-2.9-0.2-4c-1.2-1.1-2.9-1-4,0.2c-0.5,0.5-0.7,1.2-0.7,1.9 c1.2,1,1.3,2.7,0.3,3.9c0,0-0.1,0.1-0.1,0.1c0,0.8,0.4,1.6,1,2.2c-1.3,0.9-1.7,2.6-0.8,3.9c0.1,0.2,0.3,0.4,0.5,0.6 c0.3,2.2-0.2,4.4-1.5,6.2c2.8,0.5,5.5-1.2,6.1-4c0-0.8-0.4-1.6-1-2.1c1.2-1,1.4-2.8,0.4-3.9c-0.1-0.1-0.2-0.3-0.4-0.4 C153.4,417,153.9,416.2,153.9,415.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M162.4,418.2c2.5,0,4.6-2,4.6-4.6c0-2.5-2-4.5-4.6-4.5c-2.5,0-4.6,2-4.6,4.6l0,0 C157.9,416.1,159.9,418.2,162.4,418.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M161.5,426c-2.5,0-4.5,2-4.5,4.6c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.5C166.1,428,164,426,161.5,426 C161.5,426,161.5,426,161.5,426"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M92.3,304.8c0,2.5,2,4.5,4.5,4.5c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.5-4.5-4.5c0,0,0,0,0,0 C94.3,300.3,92.3,302.3,92.3,304.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M94.6,314.6c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6h0C96.6,310.1,94.6,312.1,94.6,314.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M96,327.5c-0.3,2.5,1.5,4.8,4,5.1s4.8-1.5,5.1-4c0.3-2.5-1.5-4.7-3.9-5.1C98.6,323.3,96.3,325,96,327.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M95.7,337.2c-0.3,2.5,1.5,4.8,3.9,5.1c2.5,0.3,4.8-1.5,5.1-3.9c0.3-2.5-1.5-4.8-3.9-5.1c0,0,0,0,0,0 C98.3,332.9,96,334.7,95.7,337.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M89.3,344.7c-0.3,2.5,1.5,4.8,4,5c2.5,0.3,4.8-1.5,5-4c0.3-2.5-1.5-4.7-4-5C91.9,340.3,89.7,342.1,89.3,344.7 C89.4,344.6,89.4,344.6,89.3,344.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M97.2,345.6c-0.3,2.5,1.5,4.8,4,5.1c2.5,0.3,4.8-1.5,5.1-4c0.3-2.5-1.5-4.8-3.9-5.1 C99.7,341.3,97.5,343.1,97.2,345.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M94,353.5c-0.3,2.5,1.5,4.8,3.9,5.1c2.5,0.3,4.8-1.5,5.1-3.9c0.3-2.5-1.5-4.8-3.9-5.1c0,0,0,0,0,0 C96.6,349.3,94.3,351,94,353.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M96.6,363.2c-0.3,2.5,1.5,4.8,4,5.1c2.5,0.3,4.8-1.5,5.1-4c0.3-2.5-1.5-4.8-3.9-5.1 C99.1,358.9,96.9,360.7,96.6,363.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M90.9,371.3c-0.3,2.5,1.5,4.8,3.9,5.1c2.5,0.3,4.8-1.5,5.1-3.9c0.3-2.5-1.5-4.8-3.9-5.1c0,0,0,0,0,0 C93.5,367,91.2,368.8,90.9,371.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M97.2,381c-0.3,2.5,1.5,4.8,4,5.1c2.5,0.3,4.8-1.5,5.1-4c0.3-2.5-1.5-4.8-3.9-5.1 C99.8,376.8,97.5,378.6,97.2,381C97.2,381,97.2,381,97.2,381"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M90.9,388.2c-0.3,2.5,1.5,4.8,4,5.1c2.5,0.3,4.8-1.5,5.1-4c0.3-2.5-1.5-4.8-3.9-5.1 C93.5,383.9,91.2,385.7,90.9,388.2C90.9,388.2,90.9,388.2,90.9,388.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M101.2,397.4c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6h0C103.2,392.8,101.2,394.9,101.2,397.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M106.4,406.1c0.6,2.4,3,4,5.4,3.4s4-3,3.4-5.4c-0.6-2.4-3-4-5.4-3.4C107.4,401.2,105.9,403.6,106.4,406.1 C106.4,406.1,106.4,406.1,106.4,406.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M110,412.2c0.6,2.4,3,4,5.5,3.4c2.4-0.6,4-3,3.4-5.5c-0.6-2.4-3-4-5.5-3.4c0,0,0,0,0,0 C111,407.3,109.4,409.7,110,412.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M113.4,419.2c0.6,2.4,3,4,5.4,3.4c2.4-0.6,4-3,3.4-5.4c-0.6-2.4-3-4-5.4-3.4 C114.3,414.3,112.8,416.8,113.4,419.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M116.6,411.3c0.6,2.4,3,4,5.5,3.4c2.4-0.6,4-3,3.4-5.5c-0.6-2.4-3-4-5.5-3.4c0,0,0,0,0,0 C117.6,406.4,116,408.9,116.6,411.3C116.6,411.3,116.6,411.3,116.6,411.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M121,417.7c0.6,2.4,3,4,5.4,3.4c2.4-0.6,4-3,3.4-5.4c-0.6-2.4-3-4-5.4-3.4C122,412.8,120.4,415.2,121,417.7 C121,417.6,121,417.6,121,417.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M155.4,249.4c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C157.4,244.8,155.4,246.8,155.4,249.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M153.8,280.9c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C155.8,276.4,153.8,278.4,153.8,280.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M154.4,265.9c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C156.4,261.3,154.4,263.4,154.4,265.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M153.1,297c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5s-2-4.6-4.5-4.6c0,0,0,0,0,0C155.1,292.5,153.1,294.5,153.1,297 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M55.5,205.5c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8c0,0,0,0,0,0 C56.8,200.7,55.1,203,55.5,205.5C55.5,205.5,55.5,205.5,55.5,205.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M53.1,214.9c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2s-2.7-4.2-5.2-3.8c0,0,0,0,0,0 C54.4,210.1,52.7,212.4,53.1,214.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M62,213c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8c0,0,0,0,0,0 C63.3,208.2,61.6,210.5,62,213C62,213,62,213,62,213"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M77.7,205.6c0.4,2.5,2.7,4.2,5.2,3.8s4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8c0,0,0,0,0,0 C79,200.8,77.3,203.2,77.7,205.6C77.6,205.6,77.6,205.6,77.7,205.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M71.4,213.3c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8c0,0,0,0,0,0 C72.7,208.5,71,210.8,71.4,213.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M81.1,215.1c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8 C82.4,210.2,80.7,212.6,81.1,215.1C81.1,215,81.1,215,81.1,215.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M85.5,224.5c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8 C86.9,219.7,85.2,222,85.5,224.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M88.7,234.6c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8 C90,229.8,88.3,232.1,88.7,234.6C88.7,234.6,88.7,234.6,88.7,234.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M94.6,227.7c0.4,2.5,2.7,4.2,5.2,3.8s4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8c0,0,0,0,0,0 C95.9,222.9,94.2,225.2,94.6,227.7C94.5,227.7,94.5,227.7,94.6,227.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M92.8,218.6c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8 C94.2,213.8,92.5,216.2,92.8,218.6C92.8,218.6,92.8,218.6,92.8,218.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M93.5,209.6c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8c0,0,0,0,0,0 C94.8,204.8,93.1,207.1,93.5,209.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M87.3,212.9c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8c0,0,0,0,0,0 C88.7,208.1,86.9,210.4,87.3,212.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M92.5,200.5c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8 C93.8,195.7,92.1,198,92.5,200.5C92.5,200.5,92.5,200.5,92.5,200.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M86.4,203.8c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8c0,0,0,0,0,0 C87.8,199,86.1,201.3,86.4,203.8C86.4,203.8,86.4,203.8,86.4,203.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M91.7,245.2c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8c0,0,0,0,0,0 C93.1,240.4,91.4,242.7,91.7,245.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M97.3,255.7c0.4,2.5,2.7,4.2,5.2,3.8c2.5-0.4,4.2-2.7,3.8-5.2c-0.4-2.5-2.7-4.2-5.2-3.8c0,0,0,0,0,0 C98.6,250.9,96.9,253.2,97.3,255.7C97.3,255.7,97.3,255.7,97.3,255.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M89.3,270.7c0,2.5,2,4.5,4.5,4.5c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.5-4.5-4.5c0,0,0,0,0,0 C91.3,266.2,89.3,268.2,89.3,270.7C89.3,270.7,89.3,270.7,89.3,270.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M94.4,278.1c0,2.5,2,4.5,4.5,4.5c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.5-4.5-4.5c0,0,0,0,0,0 C96.4,273.5,94.4,275.6,94.4,278.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M92.4,287c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.5-4.5C94.5,282.4,92.4,284.5,92.4,287 C92.4,287,92.4,287,92.4,287"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M96.9,295.2c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6h0C98.9,290.6,96.9,292.7,96.9,295.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M98.9,288.4c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6h0C101,283.9,98.9,285.9,98.9,288.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M194.2,242.2c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C196.3,237.7,194.3,239.7,194.2,242.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M187.1,226c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S187.1,223.5,187.1,226L187.1,226"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M200.3,211.1c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C202.3,206.6,200.3,208.6,200.3,211.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M189.7,194c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C191.7,189.4,189.7,191.5,189.7,194C189.7,194,189.7,194,189.7,194"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M202.3,177.9c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S202.3,175.3,202.3,177.9L202.3,177.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M170.7,192.8c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C172.8,188.3,170.7,190.3,170.7,192.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M169.6,208.5c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S169.6,206,169.6,208.5L169.6,208.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M168.9,224c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S168.9,221.5,168.9,224L168.9,224"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M167.9,240.1c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C169.9,235.5,167.9,237.6,167.9,240.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M166.8,256.7c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.5c0-2.5-2-4.6-4.6-4.6S166.8,254.2,166.8,256.7L166.8,256.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M165.7,271.5c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C167.8,266.9,165.7,269,165.7,271.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M172.1,273.6c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C174.2,269.1,172.1,271.1,172.1,273.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M158.2,202.5c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6C160.3,197.9,158.2,199.9,158.2,202.5 C158.2,202.5,158.2,202.5,158.2,202.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M158.9,187c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S158.9,184.5,158.9,187L158.9,187"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M152.8,190c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C154.8,185.4,152.8,187.5,152.8,190C152.8,190,152.8,190,152.8,190"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M143.2,191.9c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C145.3,187.4,143.3,189.4,143.2,191.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M138.1,183c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S138.1,180.5,138.1,183L138.1,183"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M146.6,178.8c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S146.6,176.2,146.6,178.8L146.6,178.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M151.1,168.4c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C153.2,163.8,151.1,165.9,151.1,168.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M141.9,164.6c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C143.9,160,141.9,162.1,141.9,164.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M144.3,203.6c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S144.3,201.1,144.3,203.6L144.3,203.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M153.4,205.3c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C155.4,200.7,153.4,202.8,153.4,205.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M157.3,217.4c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C159.4,212.9,157.3,214.9,157.3,217.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M148.2,215.4c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C150.2,210.8,148.2,212.9,148.2,215.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M135.2,214.8c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S135.2,212.3,135.2,214.8L135.2,214.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M156.3,233.1c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C158.3,228.6,156.3,230.6,156.3,233.1C156.3,233.1,156.3,233.1,156.3,233.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M164.5,302.9c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C166.5,298.3,164.5,300.3,164.5,302.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M80.7,159.3c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C82.7,154.8,80.7,156.8,80.7,159.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M189.6,174.5c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S189.6,172,189.6,174.5L189.6,174.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M171.4,177.1c0,2.5,2,4.5,4.6,4.5s4.5-2,4.5-4.6c0-2.5-2-4.5-4.5-4.5C173.5,172.6,171.5,174.6,171.4,177.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M160,170c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C162,165.5,160,167.5,160,170"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M191.8,292.5c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C193.8,288,191.8,290,191.8,292.5L191.8,292.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M165.2,287.3c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C167.2,282.8,165.2,284.8,165.2,287.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M180.5,279c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C182.6,274.5,180.5,276.5,180.5,279"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M186.6,267.8c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C188.6,263.2,186.6,265.3,186.6,267.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M175.4,252.7c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S175.4,250.2,175.4,252.7L175.4,252.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M105.3,69.4c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C107.3,64.9,105.3,66.9,105.3,69.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M105.3,78.9c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C107.3,74.3,105.3,76.4,105.3,78.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M97.6,84.1c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C99.6,79.5,97.6,81.5,97.6,84.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M92.5,107.2c0,2.5,2,4.5,4.6,4.5s4.5-2,4.5-4.6c0-2.5-2-4.5-4.5-4.5S92.5,104.7,92.5,107.2L92.5,107.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M91.4,94.2c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C93.4,89.6,91.4,91.7,91.4,94.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M92.3,101.3c0,2.5,2,4.5,4.6,4.5s4.5-2,4.5-4.6c0-2.5-2-4.5-4.5-4.5S92.3,98.8,92.3,101.3L92.3,101.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M86.1,114.2c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C88.1,109.6,86.1,111.7,86.1,114.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M91.3,132.4c0,2.5,2,4.6,4.6,4.6s4.5-2,4.5-4.6s-2-4.6-4.5-4.6S91.3,129.9,91.3,132.4L91.3,132.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M59.3,161.8c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6s-2-4.5-4.6-4.5c0,0,0,0,0,0 C61.3,157.3,59.3,159.3,59.3,161.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M57.1,170.6c0,2.5,2,4.6,4.6,4.6c2.5,0,4.5-2,4.5-4.6s-2-4.6-4.5-4.6S57.1,168,57.1,170.6L57.1,170.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M54.3,179.6c0,2.5,2.1,4.5,4.6,4.5c2.5,0,4.5-2.1,4.5-4.6c0-2.5-2.1-4.5-4.6-4.5 C56.3,175,54.3,177,54.3,179.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M53.6,189.3c0,2.5,2,4.6,4.6,4.6s4.5-2,4.5-4.6c0-2.5-2-4.6-4.5-4.6C55.6,184.8,53.6,186.8,53.6,189.3 L53.6,189.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M62.1,184.8c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C64.2,180.2,62.1,182.3,62.1,184.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M84.8,167.5c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C86.8,163,84.8,165,84.8,167.5L84.8,167.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M75,152.1c0,2.5,2,4.6,4.6,4.6s4.5-2,4.5-4.6s-2-4.6-4.5-4.6S75,149.6,75,152.1L75,152.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M193.2,71.6c0,2.5,2.1,4.5,4.6,4.5c2.5,0,4.5-2.1,4.5-4.6c0-2.5-2-4.5-4.5-4.5C195.2,67,193.2,69,193.2,71.6 L193.2,71.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M204.2,59.8c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.5c0-2.5-2-4.5-4.6-4.5S204.2,57.3,204.2,59.8 C204.2,59.8,204.2,59.8,204.2,59.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M193.7,46.2c0,2.5,2,4.5,4.6,4.5c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.5-4.6-4.5S193.7,43.7,193.7,46.2 C193.7,46.2,193.7,46.2,193.7,46.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M178.9,49.8c0,2.5,2,4.5,4.6,4.5c2.5,0,4.6-2,4.6-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C181,45.3,178.9,47.3,178.9,49.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M178,66.4c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0C180,61.8,178,63.9,178,66.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M177.1,81.9c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.6c0-2.5-2-4.5-4.6-4.5S177.1,79.4,177.1,81.9L177.1,81.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M186,80.6c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.6c0-2.5-2-4.5-4.6-4.5S186,78.1,186,80.6L186,80.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M176.1,97.8c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C178.1,93.2,176.1,95.3,176.1,97.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M175,114.2c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.6c0-2.5-2-4.5-4.6-4.5S175,111.7,175,114.2L175,114.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M174.5,129.7c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6c0-2.5-2-4.6-4.6-4.6S174.5,127.2,174.5,129.7L174.5,129.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M173.2,145.6c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S173.2,143.1,173.2,145.6L173.2,145.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M172.5,161.4c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5s-2-4.6-4.5-4.6c0,0,0,0,0,0 C174.5,156.9,172.5,158.9,172.5,161.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M180.1,157.2c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5s-2-4.6-4.5-4.6c0,0,0,0,0,0 C182.1,152.6,180.1,154.7,180.1,157.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M163.6,106.9c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.6c0-2.5-2-4.5-4.6-4.5S163.6,104.4,163.6,106.9L163.6,106.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M162.7,122.4c0,2.5,2,4.5,4.6,4.5s4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C164.7,117.9,162.7,119.9,162.7,122.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M161.8,139c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S161.8,136.5,161.8,139L161.8,139"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M160.6,154.9c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5s-2-4.6-4.5-4.6c0,0,0,0,0,0 C162.6,150.3,160.6,152.3,160.6,154.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M192.5,161.9c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S192.5,159.4,192.5,161.9L192.5,161.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M204.6,157.4c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S204.6,154.9,204.6,157.4L204.6,157.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M182.5,146.5c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C184.6,142,182.5,144,182.5,146.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M200.1,137.2c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S200.1,134.7,200.1,137.2L200.1,137.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M183.9,123.1c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.6c0-2.5-2-4.5-4.6-4.5S183.9,120.6,183.9,123.1L183.9,123.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M202.1,111.5c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.6c0-2.5-2-4.5-4.6-4.5S202.1,109,202.1,111.5L202.1,111.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M190.9,97.8c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0 C192.9,93.2,190.9,95.3,190.9,97.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M203.2,84.9c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.6c0-2.5-2-4.5-4.6-4.5S203.2,82.4,203.2,84.9L203.2,84.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M168.9,13.7c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.5s-2-4.5-4.6-4.6S168.9,11.1,168.9,13.7 C168.9,13.7,168.9,13.7,168.9,13.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M160.3,10.5c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.5-4.6-4.6S160.3,8,160.3,10.5 C160.3,10.5,160.3,10.5,160.3,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M152.2,5.8c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.5-4.6-4.6S152.2,3.2,152.2,5.8 C152.2,5.8,152.2,5.8,152.2,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M180.3,27.9c0,2.5,2,4.6,4.6,4.5c2.5,0,4.6-2,4.6-4.5s-2-4.5-4.6-4.5S180.3,25.4,180.3,27.9L180.3,27.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M179.8,37c0,2.5,2,4.5,4.6,4.5c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.5-4.6-4.5S179.8,34.5,179.8,37 C179.8,37,179.8,37,179.8,37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M151.6,18.2c0,2.5,2,4.5,4.6,4.5s4.6-2,4.6-4.5s-2-4.5-4.6-4.6S151.6,15.7,151.6,18.2 C151.6,18.2,151.6,18.2,151.6,18.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M162,24.5c0,2.5,2,4.6,4.5,4.6c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6c0,0,0,0,0,0C164,20,162,22,162,24.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M157.2,26.4c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.5s-2-4.5-4.6-4.6S157.2,23.9,157.2,26.4L157.2,26.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M107.2,399c0,2.5,2,4.5,4.5,4.5c2.5,0,4.6-2,4.6-4.5c0-2.5-2-4.5-4.5-4.5c0,0,0,0,0,0 C109.2,394.5,107.2,396.5,107.2,399C107.2,399,107.2,399,107.2,399"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M106.1,391.3c0,2.5,2,4.6,4.5,4.6s4.6-2,4.6-4.5c0-2.5-2-4.6-4.5-4.6h0C108.1,386.7,106.1,388.8,106.1,391.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M95.9,186c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6s-2-4.5-4.6-4.5c0,0,0,0,0,0 C97.9,181.5,95.9,183.5,95.9,186"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M100.4,96.6c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.5-4.5C102.5,92,100.5,94,100.4,96.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M85.2,48c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C87.2,43.5,85.2,45.5,85.2,48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M88.3,38.3c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6c0-2.5-2-4.5-4.6-4.5c0,0,0,0,0,0 C90.3,33.8,88.3,35.8,88.3,38.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M101.4,25.9c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6s-2-4.5-4.6-4.5c0,0,0,0,0,0 C103.4,21.4,101.4,23.4,101.4,25.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M101.1,9.1c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.6s-2-4.5-4.6-4.5c0,0,0,0,0,0 C103.2,4.5,101.1,6.5,101.1,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M99,17.6c0,2.5,2,4.5,4.6,4.5c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.6S99,15.1,99,17.6C99,17.6,99,17.6,99,17.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M182,134.9c0,2.5,2,4.6,4.6,4.6s4.6-2,4.6-4.6s-2-4.6-4.6-4.6S182,132.3,182,134.9L182,134.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M154.6,400.5c0-0.9-0.4-1.7-1.1-2.3c1.3-0.9,1.5-2.7,0.6-4c-0.9-1.3-2.7-1.5-4-0.6c-1.3,0.9-1.5,2.7-0.6,4 c0.2,0.2,0.4,0.4,0.6,0.6c-0.7,0.5-1.1,1.4-1.1,2.3c0,0.6,0.2,1.2,0.5,1.6c-1.2,1-1.4,2.8-0.4,4c1,1.2,2.8,1.4,4,0.4 c0.7-0.5,1-1.3,1-2.2C153.3,403.1,153.5,401.4,154.6,400.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik1);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_1.74a83e4fbae2a2a51e1b9fd21d17a9a0.svg";
export { ForwardRef as ReactComponent };